var map = {
	"./BlogHomePage.tsx": 38892,
	"./BlogListPage.tsx": 51959,
	"./BlogPage.tsx": 74140,
	"./FolderPage.tsx": 89502,
	"./WhereToBuyPage.tsx": 5453
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 16481;